var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-cell-box"},[_vm._t("default",null,{"cell":_vm.data,"index":_vm.index})],2)}
var staticRenderFns = []

export { render, staticRenderFns }